/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BrandNew_lists$ref = any;
export type BrandNewQueryVariables = {||};
export type BrandNewQueryResponse = {|
  +lists: ?{|
    +$fragmentRefs: BrandNew_lists$ref
  |}
|};
export type BrandNewQuery = {|
  variables: BrandNewQueryVariables,
  response: BrandNewQueryResponse,
|};
*/


/*
query BrandNewQuery {
  lists {
    ...BrandNew_lists
    id
  }
}

fragment BrandNew_lists on Lists {
  id
  categories(first: 1000) {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandNewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BrandNew_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "BrandNewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1000
              }
            ],
            "concreteType": "CategoryConnection",
            "kind": "LinkedField",
            "name": "categories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "categories(first:1000)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "BrandNewQuery",
    "operationKind": "query",
    "text": "query BrandNewQuery {\n  lists {\n    ...BrandNew_lists\n    id\n  }\n}\n\nfragment BrandNew_lists on Lists {\n  id\n  categories(first: 1000) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e112655e0bfb8c72d41eb74699cc3158';

module.exports = node;
